import { getAuthToken } from '../api/api';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Enlace a un fichero del servidor con el token por query (como los PDF).
// `extra` se añade tal cual al final (p. ej. '&inline=true' para verlo en el
// navegador). Las URL absolutas (Drive, etc.) se devuelven sin tocar.
export const urlConToken = (ruta, extra = '') => {
  if (!ruta) return '';
  if (/^https?:\/\//i.test(ruta)) return ruta;
  return `${API_URL}${ruta}${ruta.includes('?') ? '&' : '?'}token=${getAuthToken()}${extra}`;
};

export default urlConToken;
